import { Button } from "@/components/shared/buttons/Button";
import { CheckCircleOutline } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";

interface IProps {
    /**
     * callback to close the dialog
     */
    onClose: () => void;
}

/**
 * The success state for the clause checklist mutation
 */
export const ClauseChecklistMutationSuccess = ({ onClose }: IProps) => {
    return (
        <>
            <CheckCircleOutline
                color={"success"}
                sx={{ width: 48, height: 48 }}
            />
            <Stack alignItems={"center"}>
                <Typography variant="h6" fontWeight={600}>
                    Success
                </Typography>

                <Typography variant={"body2"} color={"textSecondary"}>
                    The clause checklist has been saved.
                </Typography>
            </Stack>

            <Box flexGrow={1} />

            <Box>
                <Button
                    type="button"
                    variant="outlined"
                    sx={{ borderRadius: 2, py: 1, minWidth: 180 }}
                    fullWidth
                    onClick={onClose}
                >
                    Close
                </Button>
            </Box>
        </>
    );
};
